// src/pages/KarigarManagement/Job/components/JobFormSteps.jsx

import React from "react";
import { CheckCircle } from "lucide-react";
import { cn } from "@/lib/utils";
import { FORM_STEPS } from "../constants/jobConstants";

/**
 * Step progress indicator component
 */
const JobFormSteps = ({ currentStep, onStepClick = null }) => {
  return (
    <div className="relative">
      <div className="flex justify-between">
        {FORM_STEPS.map((step, index) => {
          const Icon = step.icon;
          const isActive = currentStep === step.id;
          const isCompleted = currentStep > step.id;
          const isClickable = onStepClick && isCompleted;

          return (
            <div
              key={step.id}
              className={cn(
                "flex flex-col items-center gap-2 flex-1",
                index < FORM_STEPS.length - 1 && "relative"
              )}
            >
              {/* Connecting line */}
              {index < FORM_STEPS.length - 1 && (
                <div
                  className={cn(
                    "absolute top-5 left-[50%] w-full h-0.5",
                    isCompleted ? "bg-primary" : "bg-muted"
                  )}
                />
              )}

              {/* Step circle */}
              <div
                onClick={() => isClickable && onStepClick(step.id)}
                className={cn(
                  "relative z-10 h-10 w-10 rounded-full flex items-center justify-center transition-all",
                  isActive
                    ? "bg-primary text-primary-foreground ring-4 ring-primary/20"
                    : isCompleted
                    ? "bg-primary text-primary-foreground"
                    : "bg-muted text-muted-foreground",
                  isClickable && "cursor-pointer hover:ring-2 hover:ring-primary/30"
                )}
              >
                {isCompleted ? (
                  <CheckCircle className="h-5 w-5" />
                ) : (
                  <Icon className="h-5 w-5" />
                )}
              </div>

              {/* Step title */}
              <span
                className={cn(
                  "text-xs font-medium hidden sm:block",
                  isActive
                    ? "text-primary"
                    : isCompleted
                    ? "text-foreground"
                    : "text-muted-foreground"
                )}
              >
                {step.title}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default JobFormSteps;
